import { createSlice } from "@reduxjs/toolkit";

const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    crypto: null,
    sales: null,
  },
  reducers: {
    setNewCrypto(state, action) {
      state.crypto = action.payload;
    },
    setNewSales(state, action) {
      state.sales = action.payload;
    },
  },
});

export const { setNewCrypto, setNewSales } = walletSlice.actions;

export default walletSlice.reducer;
